import {IssueInProgressIcon} from '@github-ui/custom-icons/IssueInProgressIcon'
import {type Icon, IssueClosedIcon, IssueDraftIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

type StatusVisual = {icon: Icon; color: 'open' | 'done' | 'muted'}

// Keyed by name while statuses are in flux.
export const STATUS_VISUALS: Record<string, StatusVisual> = {
  New: {icon: IssueOpenedIcon, color: 'open'},
  Backlog: {icon: IssueDraftIcon, color: 'muted'},
  Todo: {icon: IssueOpenedIcon, color: 'open'},
  'In Progress': {icon: IssueInProgressIcon, color: 'open'},
  Done: {icon: IssueClosedIcon, color: 'done'},
  'Not planned': {icon: SkipIcon, color: 'muted'},
  Duplicate: {icon: SkipIcon, color: 'muted'},
}

const CATEGORY_STATUS_NAMES: Record<string, string> = {
  new: 'New',
  backlog: 'Backlog',
  planned: 'Todo',
  started: 'In Progress',
  completed: 'Done',
  'not-planned': 'Not planned',
  duplicate: 'Duplicate',
}

export function categoryStatusVisual(category: string): StatusVisual | undefined {
  const name = CATEGORY_STATUS_NAMES[category.toLowerCase().replaceAll('_', '-')]
  return name ? STATUS_VISUALS[name] : undefined
}
